import React from "react";
import { createPortal } from "react-dom";
import ProductDetailBottomSheet from "../../pages/parhato2/product-detail-sheet";
import { useProductDetailSheetStore } from "../../providers/productDetailSheetStore";

const ProductDetailPortal = () => {
  const productId = useProductDetailSheetStore((state) => state.productId);
  const portalRoot = document.getElementById("portal-root");

  if (!productId || !portalRoot) return null;

  return createPortal(
    <div className="fixed inset-0 z-[2] bg-black bg-opacity-50">
      <ProductDetailBottomSheet key={productId} />
    </div>,
    portalRoot,
  );
};

export default ProductDetailPortal;
